import React, { useState } from "react";
import { auth, db } from "./firebase";
import { signInWithEmailAndPassword, signOut } from "firebase/auth";
import { getDoc, doc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      // 🔍 Fetch user document from Firestore
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();

        // 🚫 Check for suspension
        if (userData.suspended) {
          alert("🚫 Your account has been suspended.");
          await signOut(auth);
          return;
        }

        // 🚀 Direct role-based navigation with admin support integrated
        if (userData.role === "admin") {
          navigate("/admin-dashboard");
        } else if (userData.role === "investor") {
          navigate("/investor-dashboard");
        } else {
          navigate("/dashboard");
        }
      } else {
        setError("User data not found.");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 p-6">
      <h1 className="text-3xl font-bold mb-6">Login to InvestorLanes</h1>
      <form onSubmit={handleSubmit} className="w-full max-w-sm">
        {error && <p className="mb-4 text-red-600">{error}</p>}
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full mb-4 px-3 py-2 border rounded text-gray-800 outline-none focus:ring-2 focus:ring-blue-500"
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          className="w-full mb-6 px-3 py-2 border rounded text-gray-800 outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700 font-semibold transition-colors duration-150"
        >
          Login
        </button>
      </form>

      {/* Forgot Password Link */}
      <p className="mt-4 text-center text-sm text-gray-600">
        Forgot your password?{" "}
        <Link to="/forgot-password" className="text-blue-600 hover:underline font-medium">
          Reset it here
        </Link>
      </p>

      <p className="mt-4 text-center text-sm text-gray-600">
        Don't have an account?{" "}
        <Link to="/signup" className="text-blue-600 underline font-medium">
          Sign Up
        </Link>
      </p>
    </div>
  );
};

export default Login;
